import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Title from '../../components/Title';
import IconSaving from '../../Icons/IconSaving';
import IconCar from '../../Icons/IconCar';
import Filters from './Components/Filters';
import { useValeContext } from './context/Vale.context';

interface Props {
  view: boolean;
  urlMDScrollPreferencia: string;
  filtrosVisiblesProductos: string[];
  filtrosVisiblesOtros: string[];
}

const BodyTop: FC<Props> = ({
  view,
  urlMDScrollPreferencia,
  filtrosVisiblesProductos,
  filtrosVisiblesOtros,
}) => {
  const { t } = useTranslation();
  const [filtersOpen, setFiltersOpen] = useState<boolean>(false);
  const { changeOpenFilter, existenFiltrosvisibles } = useValeContext();

  const toggleFiltersOpen = () => {
    setFiltersOpen((prevFiltersOpen) => !prevFiltersOpen);
    changeOpenFilter();
  };
  return (
    <>
      <section className="o-section--medium o-section--no-padding-top section--background">
        <div className="container">
          <div className="cabecera-seccion">
            <Title titleName={t('vales.title')} page="vales" isLoad={view} />

            <div className="links-cabecera">
              <div className="icon-link-block u-margin-bottom-small u-display-none-only-mobile-tablet a-movil">
                <a
                  href={`${
                    process.env.REACT_APP_API
                  }/clienteLogado/getTK?fromUrl=${
                    process.env.REACT_APP_SERVER_EROSKI_ES
                  }${t('link.promociones')}&fromApp=${t('eroski_es')}`}
                  rel="noopener noreferrer"
                  className="icon-link u-align-items-baseline"
                >
                  <div className="icon icon-medium icon--grey ">
                    <IconSaving />
                  </div>
                  <span className="u-font-small u-text-brand u-text-decoration-underline">
                    {t('vales.promotion')}
                  </span>
                </a>
              </div>

              <div className="icon-link-block u-margin-bottom-small u-display-none-only-mobile-tablet">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href={`${
                    process.env.REACT_APP_API
                  }/clienteLogado/getTK?fromUrl=${
                    process.env.REACT_APP_SERVER_SUPER
                  }${t('link.super')}&fromApp=${t('web_ecommerce')}`}
                  className="icon-link u-align-items-baseline"
                  rel="noopener noreferrer"
                >
                  <div className="icon icon-medium icon--grey ">
                    <IconCar />
                  </div>
                  <span className="u-font-small u-text-brand u-text-decoration-underline">
                    {t('vales.superOnline')}
                  </span>
                </a>
              </div>

              <div className="icon-link-block">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href={urlMDScrollPreferencia}
                  className="icon-link u-align-items-baseline"
                >
                  {t('vales.recibos')}
                </a>
              </div>

              {existenFiltrosvisibles() ? (
                <div className="icon-link-block u-margin-bottom-small u-margin-top-small u-text-right  u-display-none-only-mobile-tablet">
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={toggleFiltersOpen}
                  >
                    {t('vales.txtBtnFiltrar')}
                  </button>
                </div>
              ) : null}

              <div className="icon-link-block" />
            </div>
          </div>
        </div>
      </section>

      <Filters
        toggleFiltersOpen={toggleFiltersOpen}
        filtersOpen={filtersOpen}
        filtrosVisiblesProductos={filtrosVisiblesProductos}
        filtrosVisiblesOtros={filtrosVisiblesOtros}
      />
    </>
  );
};

export default BodyTop;
